const WhiteLabel = () => {

  return (
    <div className="hk-pg-wrapper">
      <div className="hk-pg-body py-0">
        WhiteLabel
      </div>
    </div>
  )
}
export default WhiteLabel